export default __webpack_public_path__ + "static/media/new.ece5dbd2.webp";